module.exports = __webpack_public_path__ + "static/media/e13.dfe704ee.jpg";